'use client';

import { useEffect } from 'react';
import { captureException } from '@sentry/nextjs';
import type NextError from 'next/error';
import { Button } from '@spellix/ui';
import { fonts } from '@repo/ui';

interface GlobalErrorProperties {
  readonly error: NextError & { digest?: string };
  readonly reset: () => void;
}

const GlobalError = ({ error, reset }: GlobalErrorProperties) => {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <html lang="en" className={fonts}>
      <body>
        <h1>Oops, something went wrong</h1>
        <Button
          onClick={() => {
            reset();
          }}
        >
          Try again
        </Button>
      </body>
    </html>
  );
};

export default GlobalError;
